import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/capybar.png";
import Card from "../../components/ui/card/card";
import drinks from "../../assets/images/drinks.png";
import food from "../../assets/images/food.png";

export default function Menu() {
  const navigate = useNavigate();

  return (
    <div className="home">
      <header className="navbar">
        <div className="navbar-content">
          <nav className="nav-links">
            <a href="/">Inicio</a>
            <a href="/menu">Menú</a>
            <a href="https://www.instagram.com/capy_bar025" target="_blank" rel="noopener noreferrer">
              Contactanos
            </a>
          </nav>
          <div className="nav-logo">
            <img src={logo} alt="Capybar Bar" />
          </div>
        </div>
      </header>

      {/* Sección de Cards */}
      <main className="menu-cards">
        <Card
          title="Bebidas"
          text="Mirá nuestra carta de bebidas"
          image={drinks}
          route="/tragos"
        />
        <Card
          title="Comidas"
          text="Mirá nuestra carta de comidas"
          image={food}
          route="/comidas"
        />
      </main>

      <footer className="footer">
        <div className="footer-info">
          <p>© {new Date().getFullYear()} Capy-Bar. Todos los derechos reservados.</p>
          <p>Hecho con ❤️ por el equipo Capy-bar</p>
        </div>
      </footer>
    </div>
  );
}
